import React from 'react';

import AlertBadge from '../../AlertBadge';
import { AlertColumnValue } from '../types';
import * as styles from './styles/styles.module.scss';

type AlertColumnProps = {
  value: AlertColumnValue;
};

const AlertColumn = ({ value }: AlertColumnProps): JSX.Element => {
  const { alert_type } = value;
  return (
    <div className={styles.container}>
      <AlertBadge alertType={alert_type} />
    </div>
  );
};

export default AlertColumn;
